'use strict';

require('./utils/tileImage').hoverImage();
